import React from 'react';

import { Layout } from '@components/Layout';
import { useGenerateTypeError } from '@hooks/queries/useGenerateError';

export const TestTypeError: React.FC = () => {
  const generateError = useGenerateTypeError();

  return (
    <Layout title="TestTypeError" loading={generateError.isLoading} errors={[generateError.error]}>
      {null}
    </Layout>
  );
};
